import { L10nDate } from '@travel/i18n';
import { Search } from '@travel/icons/ui';
import { useTranslation } from '@travel/traveler-core/hooks';
import { FlatButton } from '@travel/ui';

import { DEFAULT_ADULT, DEFAULT_ROOMS } from 'constants/provider';
import { ProviderInfoQuery } from 'ProviderInformation-Types';

import styles from './searchInfoSP.module.scss';

type Props = {
  query: ProviderInfoQuery;
  onClick: () => void;
  destination: string;
};

function SearchInfoSP(props: Props) {
  const { query, onClick, destination } = props;

  const dateText = (
    <>
      {query.startDate ? (
        <L10nDate format="L" value={query.startDate} />
      ) : (
        useTranslation({ id: 'Top.Dates.Check_in' })
      )}
      &nbsp;-&nbsp;
      {query.endDate ? (
        <L10nDate format="L" value={query.endDate} />
      ) : (
        useTranslation({ id: 'Top.Dates.Check_out' })
      )}
    </>
  );

  const guestCount =
    Number(query.adults) + (query.childrenAges?.split(',').length || 0) || DEFAULT_ADULT;
  const guestText = useTranslation({
    id: 'Provider_Info.Filter.Guest_Total',
    count: guestCount,
    data: { total_number_guests: guestCount },
  });

  const roomText = useTranslation({
    id: 'Common_Plan_Details.Reservation_Details.Number_Rooms.Rooms',
    count: Number(query.noOfUnits) || DEFAULT_ROOMS,
    data: { room_count: Number(query.noOfUnits) || DEFAULT_ROOMS },
  });

  return (
    <FlatButton
      classType="secondary"
      className={styles.searchInfoWrapper}
      icon={<Search size={16} color="default" />}
      onClick={onClick}
      isSmallerButtonByDefault
      data-testid="searchBar-searchInfo-sp"
    >
      <span className={styles.destination}>{destination || ''}</span>
      {dateText}&nbsp;|&nbsp;{guestText}&nbsp;|&nbsp;{roomText}
    </FlatButton>
  );
}

export default SearchInfoSP;
